<template>
  <div class="wrap">
    <div class="card-face-container" style="position: relative">
      <div style="position: absolute;width: 6.2rem;height: 3.5rem;z-index: 99;background-color: rgba(0,0,0,0.2);border-radius: .1rem" v-if="!healthCardId">
        <div style="width: 100%;height: 100%;text-align: center;font-size: .4rem;color: red;line-height: 3.5rem" @click="$emit('addCard')">点击升级为电子健康卡</div>
      </div>
      <div @click="$emit('toDetails')">
        <img class="card-bg" src="static/img/cardnewbg.png" alt="" />
        <div class="card-top-info">
          <div class="card-top-org">广东省卫生健康委员会</div>
          <div class="card-top-title">
            <img src="static/img/icon2.png" alt="" />
            <span>电子健康卡</span>
          </div>
        </div>
        <div class="card-detail-info">
          <div class="card-user-info">
            <span class="card-user-name">{{name}}</span>
            <span class="card-user-id">{{idCard}}</span>
          </div>
          <div class="card-qrcode">
            <img class="card-qrcode-logo" src="static/img/logo_.png" alt="" />
            <img :src="qrcodeUrl" alt="" />
          </div>
        </div>
        <div class="card-footer">
          中华人民共和国国家卫生健康委员会监制
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props:{
        name:{
          type:String
        },
        idCard:{
          type:String
        },
        healthCardId:{
          type:String
        },
        qrcodeUrl:{
          type:String,
          default:'static/img/qrcode.png'
        }
      }
    }
</script>

<style scoped>
  @import "../../../static/css/card_face_temp.css";
</style>



// WEBPACK FOOTER //
// src/components/common/HealthCard.vue